<template>
  <div class="d-flex flex-column ga-2">
    <span class="text-white" :class="hasLink ? 'cursor-pointer' : ''" @click="onClick">
      {{ message.message }}
    </span>
    <div v-if="message.errorId" class="d-flex align-center ga-1">
      <span class="text-white">{{ $t('errorId') + ': ' + message.errorId }}</span>
      <sf-icon-button
        :size="20"
        color="white"
        :disabled="!isSupported"
        :icon="mdiContentCopy"
        @click="copy(message.errorId)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import SfIconButton from '@/components/button/SfIconButton.vue'
import { Message } from '@/modules/message/useMessaging'
import router from '@/router'
import { mdiContentCopy } from '@mdi/js'
import { useClipboard } from '@vueuse/core'
import { computed, PropType } from 'vue'

const props = defineProps({
  message: {
    type: Object as PropType<Message>,
    required: true
  }
})

const { copy, isSupported } = useClipboard()

const hasLink = computed(() => {
  return props.message && props.message.link != undefined && props.message.link != ''
})

const onClick = () => {
  const link = props.message.link
  if (link) {
    router.push(link)
  }
}
</script>
